import { ListActionsAndIssuesGraphRequest_Target } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { ListActionsGraphRequest_Target } from '@wavingroup/aqora-v2-crate/wavin/simulations/v1/simulations_service_pb';
import { queryOptions } from '@tanstack/react-query';
import { SystemBehaviourModel } from '~/pages/Metrics/models/SystemBehaviourModel';
import {
  listActionsAndIssuesGraph,
  listSimulationActionsGraph,
} from '~/services/api/fetchers/metrics.api';
import { getLastFiveYearsRange } from '~/shared/api/metrics.queries';
import { SimulationModel } from '~/shared/models/system/SimulationModel';

export const systemBehaviourQuery = ({
  targets,
  simulation,
}: {
  targets: ListActionsAndIssuesGraphRequest_Target[];
  simulation?: SimulationModel;
}) =>
  queryOptions({
    queryKey: ['systemBehaviour', targets],
    queryFn: async () => {
      const response = simulation
        ? await listSimulationActionsGraph({
            targets: targets as unknown as ListActionsGraphRequest_Target[],
            rangeFrom: simulation.timeFrom,
            rangeTo: simulation.timeTo,
            simulationId: simulation.id,
          })
        : await listActionsAndIssuesGraph({
            targets,
            rangeFrom: getLastFiveYearsRange().rangeFrom,
            rangeTo: getLastFiveYearsRange().rangeTo,
          });

      return new SystemBehaviourModel(response);
    },
    staleTime: 60 * 5_000,
  });
